module.exports = __webpack_public_path__ + "static/media/logo-about.76605e5d.png";